<template>
  <div>
    <v-dialog fullscreen v-model="visible_Instruction">
      <instruction-exam style="min-height: 100%" v-on:visible_instruction="visible_Instruction=false">
      </instruction-exam>
    </v-dialog>
    <v-container>
      <v-card v-if="creditionals.login && creditionals.password" class="mb-5">
        <v-card-text>
          <h2 class="mb-3">Инструкция по дистанционной сдаче внутренних вступительных испытаний КузГТУ</h2>
          <h3 class="mb-3">Уважаемый {{abiturient.first_name}} {{abiturient.last_name}}!</h3>
          <p>Процесс дистанционной сдачи каждого из вступительных испытаний будет проходить в несколько этапов:</p>
          <ul>
            <li>вход в образовательную среду электронного обучения КузГТУ;</li>
            <li>подготовка к вступительному испытанию;</li>
            <li>прохождение вступительного испытания;</li>
            <li>завершение.</li>
          </ul>

          <h3 class="my-3">Вход в образовательную среду электронного обучения КузГТУ!</h3>
          <p>Для входа в образовательную среду КузГТУ, в которой будет проходить вступительное испытание,<br>Вам необходимо перейти по адресу:
            <a target="_blank" href="https://el.kuzstu.ru">https://el.kuzstu.ru</a>
          </p>
          <div class="warning black--text pa-2">
            <div class="font-weight-bold">Ваши учетные данные для входа:</div>
            <div>Логин: <span class="font-weight-medium">{{creditionals.login}}</span></div>
            <div>Пароль: <span class="font-weight-medium">{{creditionals.password}}</span></div>
          </div>

          <div class="mt-3">Войти в образовательную среду электронного обучения желательно за 30-40 минут до начала испытания, чтобы проверить работоспособность вашего оборудования,  прикрепить фото паспорта, подключиться к видеоконференции  и пройти идентификацию личности.</div>
          <div class="mb-3">Рекомендуется использовать браузеры Google Chrome или Mozilla Firefox последних версий.</div>
          <p>
            В случае возникновения проблем с входом (нет логина и пароля, не получается войти в систему) в <a target="_blank" href="https://el.kuzstu.ru">https://el.kuzstu.ru</a> обратитесь по тел.: <a href="tel:+73842396917">+7-384-239-6917</a>.<br>
            <span class="font-weight-bold">Если у Вас возникли вопросы после входа в систему обратитесь по тел.: <a target="_blank" href="tel:+79049634414">+7-904-963-4414</a>.</span>
          </p>

          <h3 class="my-3">Подготовка к вступительному испытанию</h3>
          До начала вступительного испытания:
          <ul class="mb-3">
            <li>сделайте фото, на котором Вы держите паспорт (разворот с фотографией) и смотрите в объектив камеры;</li>
            <li>прикрепите файл с фотографией, перейдя по соответствующей ссылке на странице.</li>
          </ul>
          <p>
            Далее следует проверить работоспособность Вашего оборудования.<br>
            При подключении выберите «микрофон» и разрешите браузеру использовать его. Затем нажмите значок видеокамеры, разрешите браузеру использовать её. Вы должны услышать себя (подтвердите это на сайте), затем и увидеть.
          </p>

          <h3 class="my-3">Прохождение вступительного испытания</h3>
          <p>
            Прежде чем начать вступительное испытание, Вам следует подключиться к видеоконференции. Это необходимо для идентификации Вашей личности. Без прохождения процедуры идентификации личности, попытка прохождения вступительного испытания не засчитывается!<br>
            Оператор попросит Вас показать паспорт в камеру (его увидит только он). После одобрения оператора, не покидая видеоконференцию, Вы сможете перейти к самому вступительному испытанию. Покидать видеоконференцию во время прохождения испытания строго запрещено.
          </p>

          <h3 class="my-3">Завершение</h3>
          <p>
            Прежде чем начать вступительное испытание, Вам следует подключиться к видеоконференции. Это необходимо для идентификации Вашей личности. Без прохождения процедуры идентификации личности, попытка прохождения вступительного испытания не засчитывается!<br>
            Оператор попросит Вас показать паспорт в камеру (его увидит только он). После одобрения оператора, не покидая видеоконференцию, Вы сможете перейти к самому вступительному испытанию. Покидать видеоконференцию во время прохождения испытания строго запрещено.
          </p>
          <p>
            Нажмете кнопку "Отправить всё и завершить тест". Не покидайте конференцию до выполнения указанного действия!
            По окончании прохождения вступительного испытания покиньте конференцию и сайт <a target="_blank" href="https://el.kuzstu.ru">https://el.kuzstu.ru</a>.
          </p>
          <h3 class="my-3">Ожидайте результатов проверки через два дня на сайте <a target="_blank" href="https://kuzstu.ru">КузГТУ</a>.</h3>
          <h2 class="mt-5">Успехов Вам!</h2>
        </v-card-text>
      </v-card>


      <v-card outlined class="mb-5">
        <v-card-title class="font-weight-light">
          Подача заявления в приемную комиссию
        </v-card-title>
        <v-card-subtitle>
          Пожалуйста, перед подачей заявления ознакомьтесь с документами в разделе
          <a class="font-weight-regular indigo--text"
             v-bind:href="'https://kuzstu.ru/abiturientu/'"
             target="_blank"
          >Абитуриент 2026</a>
        </v-card-subtitle>
        <v-card-subtitle>
          Полный пакет документов можно скачать здесь:
          <a class="font-weight-regular indigo--text"
             v-bind:href="'/files/package/package_docs.zip'"
          >Бланки для подачи документов</a>
          Обратите внимание, что необходимые бланки продублированы в каждом шаге подачи заявления.
        </v-card-subtitle>
        <v-card-text>
          <div>
            <v-btn v-if="!abiturient.current_application_id" color="success" :to="{name: 'profile_application'}">
              Создать заявление
            </v-btn>
            <v-dialog v-else v-model="dialog" persistent max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="success" v-bind="attrs" v-on="on">
                  <span>Создать заявление</span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-body-1 font-weight-regular">
                  У вас есть незаполненное заявление (черновик)!
                </v-card-title>
                <v-card-text>Вы можете перейти в него или создать новое пустое заявление.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="dialog = false" :to="{name: 'profile_application'}">
                    Перейти в черновик
                  </v-btn>
                  <v-btn color="darken-1" text @click="dialog = false" :to="{name: 'profile_application_reset'}">
                    Новое
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

        </v-card-text>
      </v-card>

      <v-card v-if="applicationsCompleted.length" class="mb-10">
        <v-card-title class="font-weight-light">Поданные заявления в приемную комиссию</v-card-title>
        <v-alert
          type="info"
          class="mx-4 text-body-2 mb-0"
        >
          <p class="mb-0">
            Если вам необходимо отправить дополнительные (исправленные) документы в приемную комиссию,
            вы можете это сделать через созданное заявление (список ниже).
          </p>
          <p class="mb-0">
            Перейдите в заявление и в разделе "Отправка дополнительных (исправленных) документов" прикрепите необходимые
            документы (можно несколько).
          </p>
        </v-alert>
        <v-card-text>
          <v-simple-table light>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed"
                            v-on="on">№</span>
                    </template>
                    Уникальный номер заявления.
                  </v-tooltip>
                </th>
                <th class="text-left" colspan="2">
                  <v-tooltip bottom max-width="600">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed"
                            v-on="on">Статус</span>
                    </template>
                    Текущий статус заявления.
                  </v-tooltip>
                </th>
                <th class="text-left hidden-sm-and-down">Образовательная организация</th>
                <th class="text-left hidden-sm-and-down">Уровень образования</th>
                <th class="text-left hidden-sm-and-down">Форма обучения</th>
                <th class="text-left">Дата отправки</th>
              </tr>
              </thead>
              <tbody>

              <template v-if="!applicationsCompleted">
                <tr class="text--secondary">
                  <td colspan="6">
                    У вас еще нет поданых заявлений.
                  </td>
                </tr>
              </template>
              <template v-else>
                <router-link
                  tag="tr"
                  v-for="(app) in applicationsCompleted"
                  :key="app.id"
                  :to="{name: 'profile_application_detail', params: {id: app.id}}"
                  @click.prevent
                  style="cursor: pointer"
                >
                  <td>{{ app.id }}</td>
                  <td style="max-width: 28px">
                    <div v-if="app.is_close && !app.is_reject">
                      <v-icon color="red" class="hidden-sm-and-down">{{ icons.mdiCloseCircle }}</v-icon>
                    </div>
                    <span v-else-if="app.is_done">
                    <v-icon color="success" class="hidden-sm-and-down">{{ icons.mdiChevronDownCircle }}</v-icon>
                  </span>
                    <span v-else-if="app.is_reject && app.is_work">
                    <v-icon color="indigo" class="hidden-sm-and-down">{{ icons.mdiCircleSlice6 }}</v-icon>
                  </span>
                    <span v-else-if="app.is_reject && app.is_close">
                    <v-icon color="indigo" class="hidden-sm-and-down">{{ icons.mdiCircleSlice6 }}</v-icon>
                  </span>
                    <span v-else-if="app.is_reject && !app.is_work && !app.is_close">
                    <v-icon color="warning" class="hidden-sm-and-down">{{ icons.mdiCircleSlice5 }}</v-icon>
                  </span>
                    <span v-else-if="app.is_work">
                    <v-icon color="indigo" class="hidden-sm-and-down">{{ icons.mdiCircleSlice3 }}</v-icon>
                  </span>
                    <span v-else>
                    <v-icon color="blue" class="hidden-sm-and-down">{{ icons.mdiCircleSlice1 }}</v-icon>
                  </span>
                  </td>
                  <td>
                    <span v-if="app.is_close && !app.is_reject">
                      Отклонено
                    </span>
                    <span v-else-if="app.is_done">
                      Принято
                    </span>
                    <span v-else-if="app.is_reject && app.is_work">
                      Ожидает проверки
                    </span>
                    <span v-else-if="app.is_reject && app.is_close">
                      На проверке
                    </span>
                    <span v-else-if="app.is_reject && !app.is_work && !app.is_close">
                      Требуется доработка
                    </span>
                    <span v-else-if="app.is_work">
                      На проверке
                    </span>
                    <span v-else>
                      Ожидает проверки
                    </span>
                  </td>

                  <td class="hidden-sm-and-down">{{ app.campaign.name }}</td>
                  <td class="hidden-sm-and-down">{{ app.application_type.education_level_name }}</td>
                  <td class="hidden-sm-and-down">{{ app.application_type.form_name }}</td>
                  <td>{{ app.completed_datetime }}</td>
                </router-link>
              </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-text>
          <v-expansion-panels flat>
            <v-expansion-panel class="text--secondary text-body-2">
              <v-expansion-panel-header class="text-body-2">Возможные статусы заявления</v-expansion-panel-header>
              <v-expansion-panel-content>
                <ul class="text-justify">
                  <li>ожидает проверки &mdash; электронное заявление сформировано и отправлено оператору;</li>
                  <li>на проверке &mdash; оператор начал проверку заявления;</li>
                  <li>требуется доработка &mdash; оператор проверил заявление, но принять его в работу не смог.
                    На странице просмотра заявления вы можете увидеть сообщение с причиной и исправить замечания,
                    с помощью прикрепления необходимых документов. После этого заявление повторно отправляется на
                    проверку
                    оператору;
                  </li>
                  <li>принято &mdash; оператор принял заявление и сформировал личное дело,
                    теперь вы должны появиться в конкурсных списках поступающих на сайте
                    <a class="font-weight-regular indigo--text"
                       v-bind:href="'https://kuzstu.ru/abiturientu/usloviya-postupleniya/podannie-dokumenti/'"
                       target="_blank"
                    >Абитуриент 2026</a> (у филиалов другие списки), в соответствующем разделе (список обновляется в
                    конце
                    рабочего дня):
                    ;
                  </li>
                  <li>отклонено &mdash; оператор отклонил (удалил) ваше заявление. Работа по данному заявлению
                    прекращена.
                  </li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-container>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import InstructionExam from "../../../components/profile/InstructionExam";
import {
  mdiChevronDownCircle,
  mdiCircleEditOutline,
  mdiCircleSlice1,
  mdiCircleSlice3,
  mdiCircleSlice5,
  mdiCircleSlice6,
  mdiCloseCircle,
  mdiInformationVariant,
  mdiSchool,
  mdiAlertOutline,
} from "@mdi/js";

import Vue from "vue";
import axios from "axios";

export default {
  name: "List",
  components: {
    InstructionExam,
  },
  data() {
    return {
      icons: {
        mdiCircleSlice1,
        mdiCircleSlice3,
        mdiCircleSlice5,
        mdiCircleSlice6,
        mdiCloseCircle,
        mdiCircleEditOutline,
        mdiChevronDownCircle,
        mdiSchool,
        mdiInformationVariant,
        mdiAlertOutline,
      },
      dialog: false,
      visible_Instruction: false,
      creditionals: {},
    }
  },
  mounted() {
    this.$store.dispatch("applications/listApplications");
  },
  computed: {
    ...mapGetters("applications", ["applications", "applicationsCompleted", "applicationsNotCompleted", "distanceExam"]),
    ...mapGetters("abiturient", ["abiturient", "user_moodle", "mag_portal_exams"]),
  },
  async beforeRouteEnter(to, from, next) {
    await next(vm => vm.initData())
  },
  methods: {
    async initData() {
      await Vue.axios.get('application/list/')
        .then((response) => {
          let applications = response.data.map(a => a.id);

          axios.get('https://portal.kuzstu.ru/api/distant_abits', {params: {applications}})
           .then(response => {
              this.creditionals = response.data
            })

        })
    },
  }
}
</script>
